module.exports = __webpack_public_path__ + "lock.c02d45d6.svg";